/**
 * voiceDumpModes.js — Page-aware mode detection utility.
 * 
 * Isolated from VoiceDumpWizard to avoid circular imports
 * when Sidebar needs to call getModeFromPath.
 */

/**
 * Maps the current URL path to a Voice Dump mode hint.
 * Used for page-aware auto-selection when opening via keyboard shortcut or sidebar.
 */
export function getModeFromPath(pathname) {
  if (!pathname) return undefined;
  const p = pathname.toLowerCase();
  if (p.includes('/identities')) return 'identities';
  if (p.includes('/flows') || p.includes('/flow-builder')) return 'flows';
  if (p.includes('/projects/') || p.includes('/project-detail')) return 'projects';
  if (p.includes('/focus')) return 'session-planning';
  if (p.includes('/review')) return 'weekly-planning';
  // General for: inbox, dashboard, tasks, settings, etc.
  return undefined;
}
